import React from "react";
import { components, GroupBase, SingleValueProps } from "react-select";
import { MenuItem } from "../../../../../../components/@types";
import ClassificationIcon from "../../../../../../components/ClassificationIcon";

const { SingleValue } = components;

export function CustomSingleValue<
  Option extends MenuItem,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: SingleValueProps<Option, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};
  const { label, value } = props.data;

  return (
    <SingleValue {...props}>
      <span data-testid={`${testIdKey}_field_singeValue_${value || label}`}>
        {props.data.label}
      </span>
    </SingleValue>
  );
}

export function CustomClassificationSingleValue<
  Option extends MenuItem,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: SingleValueProps<Option, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};
  const { label, value } = props.data;

  return (
    <SingleValue {...props}>
      <span
        data-testid={`${testIdKey}_field_classification_singeValue_${
          value || label
        }`}
        style={{ display: "flex", alignItems: "center" }}
      >
        <ClassificationIcon
          classification={props.data.value}
          classificationStyle={{
            paddingRight: "10px",
            flexGrow: 0
          }}
        />
        {props.data.label}
      </span>
    </SingleValue>
  );
}
